import style from "./Badge.module.css";

function Bedge() {
	return (
		<div className={style.badge}>
			<span>premium</span>
		</div>
	);
}

export default Bedge;
